import { camelCaseKeys } from '@/utils/changeCase';

import { ScheduledBuildParams } from '../scheduledBuilds.types';

const parseBuildParams = (paramsString: string): ScheduledBuildParams => {
  let buildParams = [];
  try {
    buildParams = JSON.parse(paramsString);
  } catch (error) {
    console.log(error);
  }
  return camelCaseKeys(buildParams);
};

export default parseBuildParams;
